import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { setupPwa } from '@/lib/pwa';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Offer an update instead of force-reloading a developer mid-triage.
setupPwa((update) => {
  if (window.confirm('A new version of Reality Alerts is available. Reload now?')) update();
});
